import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AppRoutes, AppRoutesFlow } from 'src/app/app-routing.module';
import { HeaderNewComponent } from '../header/header-new.component';
import { FooterComponent } from '../footer/footer.component';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { ResetAllStates } from 'src/app/state/reset.reducer';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule,HeaderNewComponent,FooterComponent,BottomNavComponent],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

    backRoute: string = AppRoutesFlow.CUSTOMER_SEARCH;
  
  landingOptions = [
      {
      id: 'change-address',
      title: 'Adressänderung',
      subtitle: 'Hier können Sie die Wohnadresse des Kunden ändern.',
      icon: 'user-check',
      type: 'navigate',
      action: 'change-address'
    },
    {
      id: 'change-contact',
      title: 'Mobilnummernänderung',
      subtitle: 'Hier können Sie die Telefonnummer des Kunden ändern.',
      icon: 'mobile',
      type: 'navigate',
      action: 'change-contact'
    },
    {
      id: 'change-name',
      title: 'Namensänderung',
      subtitle: 'Aktualisieren Sie hier den Namen des Kunden.',
      icon: 'mobile',
      type: 'navigate',
      action: 'change-name'
    },
     {
      id: 'change-email',
      title: 'E-Mail-Adressänderung',
      subtitle: 'Aktualisierern Sie hier die E-Mail-Adresse des Kunden.',
      icon: 'mobile',
      type: 'navigate',
      action: 'change-email'
    },
  
  ];

  constructor(private router: Router, private sessionStorage: SessionStorageService,private store: Store,) {}

  ngOnInit(): void {}

  toggleExpand(item: any): void {
    if (item.type === 'navigate') {
      this.handleNavigation(item.action);
    }
  }

  handleNavigation(action: string): void {
    console.log('Navigation action:', action);
    switch (action) {
      case 'change-contact':
         this.sessionStorage.storeProductName('change-contact');
        this.router.navigate([AppRoutes.FLOW, 'data', AppRoutesFlow.CUSTOMER_SEARCH], { queryParams: { formName: 'change-contact' } });
       
        break;
      case 'change-address':
         this.sessionStorage.storeProductName('change-address');
        this.router.navigate([AppRoutes.FLOW, 'data', AppRoutesFlow.CUSTOMER_SEARCH], { queryParams: { formName: 'change-address'} });
        break;
          case 'change-name':
         this.sessionStorage.storeProductName('change-name');
        this.router.navigate([AppRoutes.FLOW, 'data', AppRoutesFlow.CUSTOMER_SEARCH], { queryParams: { formName: 'change-name'} });
        break;  
         case 'change-email':
         this.sessionStorage.storeProductName('change-email');
        this.router.navigate([AppRoutes.FLOW, 'data', AppRoutesFlow.CUSTOMER_SEARCH], { queryParams: { formName: 'change-email'} });
        break;  
      default:
        console.log('Unknown navigation action:', action);
    }
  }

  getIconClass(iconName: string): string {
    const iconMap: { [key: string]: string } = {
      'mobile': 'fas fa-mobile-alt',
      'user-check': 'fas fa-user-check'
    };
    return iconMap[iconName] || 'fas fa-circle';
  }

  onBack() {
       sessionStorage.clear();
       this.store.dispatch(new ResetAllStates());
      // this.keycloak.logout(window.location.origin);
        window.location.href = window.location.origin;
    }
}
